var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alert-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-32.000000, -306.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-filled",
    transform: "translate(32.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5.71875 C16.1291953,5.71875 19.4765625,9.06611719 19.4765625,13.1953125 L19.4765625,18.65625 C19.4765625,19.0704609 19.1407734,19.40625 18.7265625,19.40625 L5.2734375,19.40625 C4.85922656,19.40625 4.5234375,19.0704609 4.5234375,18.65625 L4.5234375,13.1953125 C4.5234375,9.06611719 7.87080469,5.71875 12,5.71875 Z M11.34375,1.59375 L12.65625,1.59375 C12.7598034,1.59375 12.84375,1.67769661 12.84375,1.78125 L12.84375,4.03125 C12.84375,4.13480339 12.7598034,4.21875 12.65625,4.21875 L11.34375,4.21875 C11.2401966,4.21875 11.15625,4.13480339 11.15625,4.03125 L11.15625,1.78125 C11.15625,1.67769661 11.2401966,1.59375 11.34375,1.59375 Z M4.15441406,4.49196094 C4.18957741,4.45679578 4.23727023,4.43704004 4.287,4.43704004 C4.33672977,4.43704004 4.38442259,4.45679578 4.41958594,4.49196094 L6.01057031,6.08294531 C6.04573547,6.11810866 6.06549121,6.16580148 6.06549121,6.21553125 C6.06549121,6.26526102 6.04573547,6.31295384 6.01057031,6.34811719 L5.08249219,7.27619531 C5.04732884,7.31136047 4.99963602,7.33111621 4.94990625,7.33111621 C4.90017648,7.33111621 4.85248366,7.31136047 4.81732031,7.27619531 L3.22633594,5.68521094 C3.19117078,5.65004759 3.17141504,5.60235477 3.17141504,5.552625 C3.17141504,5.50289523 3.19117078,5.45520241 3.22633594,5.42003906 L4.15441406,4.49196094 L4.15441406,4.49196094 Z M19.8481172,4.49196094 L20.7761953,5.42003906 C20.8113605,5.45520241 20.8311162,5.50289523 20.8311162,5.552625 C20.8311162,5.60235477 20.8113605,5.65004759 20.7761953,5.68521094 L19.1852109,7.27619531 C19.1500476,7.31136047 19.1023548,7.33111621 19.052625,7.33111621 C19.0028952,7.33111621 18.9552024,7.31136047 18.9200391,7.27619531 L17.9919609,6.34811719 C17.9567958,6.31295384 17.93704,6.26526102 17.93704,6.21553125 C17.93704,6.16580148 17.9567958,6.11810866 17.9919609,6.08294531 L19.5829453,4.49196094 C19.6181087,4.45679578 19.6658015,4.43704004 19.7155312,4.43704004 C19.765261,4.43704004 19.8129538,4.45679578 19.8481172,4.49196094 L19.8481172,4.49196094 Z M4.5,20.90625 L19.5,20.90625 C19.9142109,20.90625 20.25,21.2420391 20.25,21.65625 L20.25,22.21875 C20.25,22.3223034 20.1660534,22.40625 20.0625,22.40625 L3.9375,22.40625 C3.83394661,22.40625 3.75,22.3223034 3.75,22.21875 L3.75,21.65625 C3.75,21.2420391 4.08578906,20.90625 4.5,20.90625 Z M7.96875,13.4765625 L7.96875,19.40625 L9.46875,19.40625 L9.46875,13.4765625 L7.96875,13.4765625 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.56cb5810ecb38fb36493a007aea80db0.svg";
export { ForwardRef as ReactComponent };